import React from 'react';
import { Slider } from 'react-typeform-embed';

import './wrapper.scss';

const TypeformButtonWrapper = ({ children, options = {} }) => {
  /** documentation https://www.npmjs.com/package/react-typeform-embed */

  const defaultOptions = {
    id: 'nQhyMj0R',
    opacity: 100,
  };

  const parcedOptions = () => ({ ...defaultOptions, ...options });

  return <Slider {...parcedOptions()}>{children}</Slider>;
};

export default TypeformButtonWrapper;
